import UnderConstruction from "../../errors/under-construction";

const DepartmentRoleView = (): JSX.Element => {
  return <UnderConstruction />;
};

export default DepartmentRoleView;
